import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { RegionalModel } from 'src/app/core/models/regional.model';
import { UserModel } from 'src/app/core/models/user.model';
import { VoluntaryModel } from 'src/app/core/models/voluntary.model';
import { QueryParamsService } from 'src/app/core/services/query-params.service';
import { TokenAdminService } from 'src/app/core/token/token-admin.service';
import { TokenCooperativeService } from 'src/app/core/token/token-cooperative.service';
import { TokenRegionalService } from 'src/app/core/token/token-regional.service';
import { TokenVoluntaryService } from 'src/app/core/token/token-voluntary.service';
import { TokenService } from 'src/app/core/token/token.service';
import { AdminUserService } from 'src/app/core/user/admin-user.service';
import { UserCooperativeService } from 'src/app/core/user/user-cooperative.service';
import { UserRegionalService } from 'src/app/core/user/user-regional.service';
import { UserVoluntaryService } from 'src/app/core/user/user-voluntary.service';
import { UserService } from 'src/app/core/user/user.service';

import { LayoutUtilsService } from './layout-utils.service';
import { CooperativeModel } from 'src/app/core/models/cooperative.model';

@Injectable()
export class InterceptService implements HttpInterceptor {
  constructor(
    private tokenService: TokenService,
    private tokenAdminService: TokenAdminService,
    private tokenVoluntaryService: TokenVoluntaryService,
    private tokenRegionalService: TokenRegionalService,
    private tokenCooperativeService: TokenCooperativeService,

    private adminUserService: AdminUserService,
    private voluntaryUserService: UserVoluntaryService,
    private cooperativeUserService: UserCooperativeService,
    private regionalUserService: UserRegionalService,
    private userService: UserService,

    private layoutUtilsService: LayoutUtilsService,
    private queryParamsService: QueryParamsService,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const headers: any = {};

    if (
      this.tokenService.hasToken() &&
      !this.userService.isTokenExpired() &&
      this.userService.hasRole(UserModel.ROLES.ROLE_USER.CODE) &&
      window.location.hash.indexOf('admin') === -1 &&
      window.location.hash.indexOf('/pp') === -1 &&
      window.location.hash.indexOf('voluntary') === -1 &&
      window.location.hash.indexOf('/regional') === -1 &&
      window.location.hash.indexOf('/cooperative') === -1
    ) {
      headers.Authorization = `Bearer ${this.tokenService.getToken()}`;
    }

    if (
      this.tokenVoluntaryService.hasToken() &&
      !this.voluntaryUserService.isTokenExpired() &&
      this.voluntaryUserService.hasRole(
        VoluntaryModel.ROLES.ROLE_VOLUNTARY.CODE,
      ) &&
      window.location.hash.indexOf('admin') === -1
    ) {
      headers.Authorization = `Bearer ${this.tokenVoluntaryService.getToken()}`;
    }

    if (
      this.tokenRegionalService.hasToken() &&
      !this.regionalUserService.isTokenExpired() &&
      this.regionalUserService.hasRole(
        RegionalModel.ROLES.ROLE_REGIONAL.CODE,
      ) &&
      window.location.hash.indexOf('admin') === -1
    ) {
      headers.Authorization = `Bearer ${this.tokenRegionalService.getToken()}`;
    }

    if (
      this.tokenCooperativeService.hasToken() &&
      !this.cooperativeUserService.isTokenExpired() &&
      this.cooperativeUserService.hasRole(
        CooperativeModel.ROLES.ROLE_COOPERATIVE.CODE,
      ) &&
      window.location.hash.indexOf('admin') === -1
    ) {
      headers.Authorization = `Bearer ${this.tokenCooperativeService.getToken()}`;
    }

    if (
      this.tokenAdminService.hasToken() &&
      !this.adminUserService.isTokenExpired() &&
      this.adminUserService.hasRole('ROLE_ADMIN') &&
      window.location.hash.indexOf('admin') !== -1 &&
      window.location.hash.indexOf('voluntary') === -1 &&
      window.location.hash.indexOf('/regional') === -1 &&
      window.location.hash.indexOf('/cooperative') === -1
    ) {
      headers.Authorization = `Bearer ${this.tokenAdminService.getToken()}`;

      if (request.method === 'GET') {
        const url = new URL(request.urlWithParams);
        if (url.searchParams.size > 0) {
          this.queryParamsService.setQueryParamItem(
            request.urlWithParams.split('?')[0].split('/api/')[1],
            url.searchParams,
          );
        }
      }
    }

    if (
      this.tokenAdminService.hasToken() &&
      (this.adminUserService.isTokenExpired() ||
        !this.adminUserService.isLogged()) &&
      window.location.hash.indexOf('admin') !== -1 &&
      window.location.hash.indexOf('voluntary') === -1 &&
      window.location.hash.indexOf('/regional') === -1 &&
      window.location.hash.indexOf('/cooperative') === -1
    ) {
      this.adminUserService.logout();
      window.location.href = '/#/auth-admin/login';

      // cancel request
      return new Observable<HttpEvent<any>>();
    }

    const params = {} as any;

    if (
      window.location.hash.indexOf('event-public-inspection') !== -1 &&
      window.location.hash.indexOf('event-public-inspection-delivery') === -1
    ) {
      if (
        window.location.hash.indexOf('event-public-inspection-quotation') !== -1
      ) {
        params['publicInspectionToken'] = window.location.hash.split(
          'event-public-inspection-quotation/',
        )[1];
      } else {
        params['publicInspectionToken'] = window.location.hash.split(
          'event-public-inspection/',
        )[1];
      }
    }

    if (
      window.location.hash.indexOf('event-public-inspection-delivery') !== -1
    ) {
      params['publicInspectionDeliveryToken'] = window.location.hash.split(
        'event-public-inspection-delivery/',
      )[1];
    }

    if (window.location.hash.indexOf('event-public-third-party') !== -1) {
      params['publicThirdPartyToken'] = window.location.hash.split(
        'event-public-third-party/',
      )[1];
    }

    if (window.location.hash.indexOf('event-public-driver-monitoring') !== -1) {
      params['publicDriverMonitoringToken'] = window.location.hash.split(
        'event-public-driver-monitoring/',
      )[1];
    }

    if (window.location.hash.indexOf('event-public-quotation') !== -1) {
      params['publicQuotationToken'] = window.location.hash.split(
        'event-public-quotation/',
      )[1];
    }

    if (window.location.hash.indexOf('payment-public') !== -1) {
      params['paymentPublicToken'] =
        window.location.hash.split('payment-public/')[1];
    }

    const onlineInspectionId = window.localStorage.getItem(
      'onlineInspectionId',
    ) as any;

    if (
      onlineInspectionId &&
      (window.location.hash.indexOf('online-inspection') !== -1 ||
        window.location.hash.indexOf('v4/vistoria') !== -1)
    ) {
      params['onlineInspectionId'] = onlineInspectionId;
    }

    if (Object.keys(headers).length > 0 || Object.keys(params).length > 0) {
      const obj = {} as any;

      if (Object.keys(headers).length > 0) {
        obj['setHeaders'] = headers;
      }

      if (Object.keys(params).length > 0) {
        obj['setParams'] = params;
      }

      request = request.clone(obj);
    }

    return next.handle(request).pipe(
      tap(
        (event) => {
          if (event instanceof HttpResponse) {
            // console.log('all looks good');
            // http response status code
            // console.log(event.status);
          }
        },
        (err) => {
          if (
            window.location.hash.indexOf('admin') === -1 &&
            window.location.hash.indexOf('voluntary') === -1 &&
            window.location.hash.indexOf('regional') === -1 &&
            window.location.hash.indexOf('cooperative') === -1 &&
            err.status === 401
          ) {
            this.userService.logout();
            window.location.href = '/#/auth/login';
          }

          if (
            window.location.hash.indexOf('voluntary') !== -1 &&
            err.status === 401
          ) {
            this.voluntaryUserService.logout();
            window.location.href = '/#/auth-voluntary/login';
          }

          if (
            window.location.hash.indexOf('cooperative') !== -1 &&
            err.status === 401
          ) {
            this.cooperativeUserService.logout();
            window.location.href = '/#/auth-cooperative/login';
          }

          if (
            window.location.hash.indexOf('regional') !== -1 &&
            err.status === 401
          ) {
            this.regionalUserService.logout();
            window.location.href = '/#/auth-regional/login';
          }

          if (
            window.location.hash.indexOf('admin') !== -1 &&
            err.status === 401
          ) {
            this.adminUserService.logout();
            window.location.href = '/#/auth-admin/login';
          }

          // if (
          //   request.method === 'GET' &&
          //   (err.status.toString().substring(0, 1) === '5' ||
          //     (err.status.toString().substring(0, 1) === '4' &&
          //       err.status !== 401 &&
          //       err.status !== 403))
          // ) {
          //   this.layoutUtilsService.showActionNotification({
          //     title: 'Houve um erro na leitura dos dados',
          //     icon: 'error',
          //   });
          // }

          // if (err.status === 401 && request.url.indexOf('login') === -1) {
          //   setTimeout(() => {
          //     window.location.reload();
          //   });
          // }
        },
      ),
    );
  }
}
